module.exports = __webpack_public_path__ + "static/gallery-7-1f9cc0c1b0c1aa5db5e6cd315db3cd52.jpg";